/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { AccessRequestApprovalType } from './AccessRequestApprovalType';
import {
    AccessRequestApprovalTypeFromJSON,
    AccessRequestApprovalTypeFromJSONTyped,
    AccessRequestApprovalTypeToJSON,
    AccessRequestApprovalTypeToJSONTyped,
} from './AccessRequestApprovalType';

/**
 * 
 * @export
 * @interface RoleUpdateRequest
 */
export interface RoleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    canBeRequestedByUsers?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleUpdateRequest
     */
    organizationGroupIds?: Array<any> | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleUpdateRequest
     */
    permissionIds?: Array<any> | null;
    /**
     * 
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    tags?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof RoleUpdateRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof RoleUpdateRequest
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    requireUserOrganizationInMinSide?: boolean | null;
    /**
     * 
     * @type {AccessRequestApprovalType}
     * @memberof RoleUpdateRequest
     */
    accessRequestApprovalType?: AccessRequestApprovalType;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    allowEndUserCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    allowEndUserAssignment?: boolean;
    /**
     * 
     * @type {any}
     * @memberof RoleUpdateRequest
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleUpdateRequest
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleUpdateRequest
     */
    helpTextReasonField?: string | null;
}



/**
 * Check if a given object implements the RoleUpdateRequest interface.
 */
export function instanceOfRoleUpdateRequest(value: object): value is RoleUpdateRequest {
    return true;
}

export function RoleUpdateRequestFromJSON(json: any): RoleUpdateRequest {
    return RoleUpdateRequestFromJSONTyped(json, false);
}

export function RoleUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'canBeRequestedByUsers': json['canBeRequestedByUsers'] == null ? undefined : json['canBeRequestedByUsers'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'organizationGroupIds': json['organizationGroupIds'] === undefined ? undefined : json['organizationGroupIds'] === null ? null : json['organizationGroupIds'],
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'tags': json['tags'] === undefined ? undefined : json['tags'] === null ? null : json['tags'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] === undefined ? undefined : json['requireUserOrganizationInMinSide'] === null ? null : json['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': json['accessRequestApprovalType'] == null ? undefined : AccessRequestApprovalTypeFromJSON(json['accessRequestApprovalType']),
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'allowEndUserCreation': json['allowEndUserCreation'] == null ? undefined : json['allowEndUserCreation'],
        'allowEndUserAssignment': json['allowEndUserAssignment'] == null ? undefined : json['allowEndUserAssignment'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
    };
}

export function RoleUpdateRequestToJSON(json: any): RoleUpdateRequest {
    return RoleUpdateRequestToJSONTyped(json, false);
}

export function RoleUpdateRequestToJSONTyped(value?: RoleUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'canBeRequestedByUsers': value['canBeRequestedByUsers'],
        'description': value['description'],
        'isGlobal': value['isGlobal'],
        'name': value['name'],
        'organizationGroupIds': value['organizationGroupIds'],
        'permissionIds': value['permissionIds'],
        'shortName': value['shortName'],
        'tags': value['tags'],
        'userType': UserTypeToJSON(value['userType']),
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': AccessRequestApprovalTypeToJSON(value['accessRequestApprovalType']),
        'requiresMfa': value['requiresMfa'],
        'allowEndUserCreation': value['allowEndUserCreation'],
        'allowEndUserAssignment': value['allowEndUserAssignment'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
    };
}

